import type { FC, ReactNode } from 'react'
import type { Settings } from '@/types/content'

import Link from 'next/link'
import { cn } from '@/lib/utils'
import { cms, hasValue } from '@/lib/cms'

interface BrandMarkProps {
    settings: Settings
    tone?: 'light' | 'dark'
    className?: string
    onClick?: () => void
}

// Wordmark: brand name in condensed capitals with the subtitle as a mono label.
export const BrandMark: FC<BrandMarkProps> = ({ settings, tone = 'light', className, onClick }): ReactNode => {
    return (
        <Link
            href='/'
            onClick={onClick}
            className={cn('group flex flex-col leading-none', tone === 'dark' ? 'text-bone' : 'text-ink', className)}
        >
            <span className='flex items-start gap-1'>
                <span
                    data-mdlfy-cms={cms('einstellungen', settings.id, 'markenname')}
                    className='type-display text-[1.6rem] leading-[0.85] sm:text-[1.75rem]'
                >
                    {settings.markenname}
                </span>
                <span aria-hidden='true' className='mt-0.5 size-1.5 shrink-0 bg-ember transition-transform duration-500 ease-brand group-hover:rotate-45' />
            </span>

            {hasValue(settings.untertitel) && (
                <span
                    data-mdlfy-cms={cms('einstellungen', settings.id, 'untertitel')}
                    className={cn('type-label mt-1.5 text-[0.625rem]', tone === 'dark' ? 'text-ash' : 'text-smoke')}
                >
                    {settings.untertitel}
                </span>
            )}
        </Link>
    )
}
